module.exports = __webpack_public_path__ + "static/media/HomeClic-ios.a09500a0.png";